module.exports = "<div class=\"tmenu\">\r\n  <app-menu> </app-menu>\r\n</div>\r\n<router-outlet></router-outlet>\r\n"